import { z } from 'zod';
import { itemLevelSchema } from './item-level';

/**
 * Zod schema for item type domain model.
 *
 * This represents the domain model of an item type with its associated level.
 */
export const itemTypeSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  description: z.string().optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  itemLevel: itemLevelSchema,
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
  createdBy: z.string(),
  updatedBy: z.string(),
  archivedAt: z.number().int().optional(),
});

export type ItemTypeDTO = z.infer<typeof itemTypeSchema>;
